import { Component, Input } from '@angular/core';
import { BaseAlgorithmClass } from '../base-algorithm-class';

@Component({
    selector: 'app-sac-parameters',
    templateUrl: './sac-parameters.component.html',
    styleUrls: [
        '../../shared/algorithm-parameters.scss',
        './sac-parameters.component.scss',
    ],
    standalone: false,
})
export class SacParametersComponent extends BaseAlgorithmClass {
    @Input() advancedSettingEnabled: boolean = false;

    constructor() {
        super();
    }
}
